export default function(id) {
    this.id = id;
    this.show = false;
    this.name = null;
    this.gender = null;
    this.birthdate = null;
}
